/**
 * Team / country name localization.
 *
 * Country names are static — they don't need to be admin-editable like news or
 * rules. We store a frontend-only English map keyed by the same ISO-ish team
 * code the backend uses (MEX, BRA, ENG, ...).
 *
 * Use `teamLabel(code, fallback, lang)`:
 *   - If lang === "en" and we have an entry, return the English name.
 *   - Otherwise return the provided fallback (which is the backend Spanish name)
 *     or the code itself if nothing is provided.
 */

const TEAM_NAMES_EN = {
  MEX: "Mexico",
  RSA: "South Africa",
  KOR: "South Korea",
  CZE: "Czech Republic",
  CAN: "Canada",
  BIH: "Bosnia and Herzegovina",
  QAT: "Qatar",
  SUI: "Switzerland",
  BRA: "Brazil",
  MAR: "Morocco",
  HAI: "Haiti",
  SCO: "Scotland",
  USA: "United States",
  PAR: "Paraguay",
  AUS: "Australia",
  TUR: "Türkiye",
  GER: "Germany",
  CUW: "Curaçao",
  CIV: "Côte d'Ivoire",
  ECU: "Ecuador",
  NED: "Netherlands",
  JPN: "Japan",
  SWE: "Sweden",
  TUN: "Tunisia",
  BEL: "Belgium",
  EGY: "Egypt",
  IRN: "Iran",
  NZL: "New Zealand",
  ESP: "Spain",
  CPV: "Cape Verde",
  KSA: "Saudi Arabia",
  URU: "Uruguay",
  FRA: "France",
  SEN: "Senegal",
  IRQ: "Iraq",
  NOR: "Norway",
  ARG: "Argentina",
  ALG: "Algeria",
  AUT: "Austria",
  JOR: "Jordan",
  POR: "Portugal",
  COD: "DR Congo",
  UZB: "Uzbekistan",
  COL: "Colombia",
  ENG: "England",
  CRO: "Croatia",
  GHA: "Ghana",
  PAN: "Panama",
};

export function teamLabel(code, fallback, lang) {
  if (!code) return fallback || "";
  if (lang === "en") {
    const en = TEAM_NAMES_EN[code];
    if (en) return en;
  }
  return fallback || code;
}

export default TEAM_NAMES_EN;
